import {useEffect, useMemo, useState} from "react";

import {BatchScoreOverrideRequestDTO, ScoreOverrideRequestDTO} from '../../service/model/ScoreOverrideDTO';


import styles from "./AssessmentManager.module.css";
import {useFilters, useGlobalFilter, useSortBy, useTable} from "react-table";
import Loading from "../../components/Loading/Loading";
import Select from "../../components/controls/Select/Select";

import GenericModal from "../../UI/GenericModal";

// import { allPeriodsDetails } from './getAllPeriodsDetailsResponse';
import SubmitButton from "../../components/controls/SubmitButton/SubmitButton";
import {useHistory, useLocation} from "react-router-dom";
import {AssessmentServiceApi} from "../../service/api/AssessmentServiceApi";

const AssessmentManagerOverride = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [initialTableData, setInitialTableData] = useState([]);

  const [isLoadingButtons, setIsLoadingButtons] = useState(false);
  const [disableButtonSave, setDisableButtonSave] = useState(false);
  const [error, setError] = useState();

  // Modal
  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();
  const [modalShowInput, setModalShowInput] = useState(false);



  const [selectOverride, setSelectOverride] = useState([]);
  const [selectedOverride, setSelectedOverride] = useState("5"); // valore di "-"

  const history = useHistory();

  const assessmentServiceApi = new AssessmentServiceApi();

  const tableColumns = useMemo(() => COLUMNS, []);

  const {
    // these are functions and arrays that the useTable hook has given to us to enable easy table creation
    // we need to use all of these for it to work
    getTableProps, // it's a function that needs to be destructured on the table tag
    getTableBodyProps, // comment
    headerGroups, // contains the column heading information which belongs in the thead tag of the table
    rows, // comment
    columns,
    prepareRow, // comment
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns: tableColumns,
      data: tableData,
      initialState: {
        // sortBy: [
        //   {
        //     id: 'fiscalYear',
        //     desc: true
        //   }
        // ]
      },
      // autoResetGlobalFilter: false,
      // autoResetPage: false,
    },
    useFilters,
    useGlobalFilter,
    useSortBy
  );


  const modalCloseHandler = () => {
    setModalShow(false);
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const fiscalYear = searchParams.get("fiscalYear");
  const period = searchParams.get("period");

  useEffect(() => {
    console.log("FY: ", fiscalYear, " Period: ", period);
    let mounted = true;

    assessmentServiceApi.getQualitativeAnswer((error, qualitativeAnswerTypes) => {
      console.log("API Response:", error, qualitativeAnswerTypes);
      if (mounted) {
        if (!error) {
          //console.log("qualitativeAnswerTypes: ", qualitativeAnswerTypes)
          const overrideValue = qualitativeAnswerTypes.map((item, index) => ({
            score: item.score !== null && item.score !== undefined ? item.score.toString() : "",
            value: (index + 1).toString(),
            name: item.answer === 'N/A' ? "-" : item.answer
          }));

          setSelectOverride(overrideValue);
        } else {
          setError(() => {
            throw new Error(error);
          });
        }
      }
    })


    //API HTTP CALLS WITH fiscalYear and Period
    assessmentServiceApi.getAssessmentOverride(fiscalYear, period, (error, integratedScoreData) => {
      console.log("API Response:", error, integratedScoreData);
      if (mounted) {
        if (!error) {

          console.log("integratedScoreData: ", integratedScoreData)

          // Ensure we're handling the data properly - it might be an array or a single object
          const dataToProcess = Array.isArray(integratedScoreData) ? integratedScoreData : [integratedScoreData];

          console.log("Assessment management Override (integratedScoreDTO):", dataToProcess);

          const overrideValues = [];
          const mappedData = []

          dataToProcess.forEach(item => {
            const overrideValue = item.overrideScoreValue;
            console.log("item: ",item)

            overrideValues.push(overrideValue);
            mappedData.push({
              fiscalYear: item.fy,
              period: item.period,
              LE: item.company,
              FdC: item.ctrf,
              qlt: item.qltScore,
              qnt: item.qntScore,
              score: item.overallScore,
              esito: item.esito,
              override: overrideValue,
              note: item.overrideComment || "",
              editable: item.editable
            });
          });

          setSelectedOverride(overrideValues);
          console.log("selectedOverride: ", selectedOverride)

          console.log("Mapped table data:", mappedData);
          setInitialTableData(mappedData)
          setTableData(mappedData);
          setIsLoading(false);
        } else {
          setError(() => {
            throw new Error(error);
          });
        }
      }
    });

    return () => {
      mounted = false;
    };
  }, []);


  useEffect(() => {
    if (rows.length === 0) {
      setDisableButtonSave(true)
    } else {
      setDisableButtonSave(false)
    }
  }, [rows.length]);



  const getRatingLabel = (x) => {
    console.log("getRatingLabel: ", x)
    if (x === null) return "N/A";
    if (x >= 0.92) return "Good";
    if (x > 0.83 && x <= 0.91) return "Satisfactory";
    if (x > 0.75 && x <= 0.83) return "Unsatisfactory";
    if (x <= 0.75) return "Poor";
  };

  const getOverrideValueFromScore = (score) => {
    if (score === null || score === undefined) return "5"; // corrisponde a "N/A" con value "5"
    if (score >= 0.92) return "1";          // Good
    if (score > 0.83 && score <= 0.91) return "2";  // Satisfactory
    if (score > 0.75 && score <= 0.83) return "3";  // Unsatisfactory
    if (score <= 0.75) return "4";          // Poor
  }

  const getScoreFromOverrideValue = (value) => {
    switch (value) {
      case "1":
        return 0.955;
      case "2":
        return 0.87;
      case "3":
        return 0.79;
      case "4":
        return 0.5;
      case "5":
        return null; // per "N/A"
      default:
        return null;
    }
  };





  const modalDataHandler = (title, message, modType, action, showModalInput = false) => {
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
    setModalAction(() => action);
    setModalShowInput(showModalInput);
  };

const getChangedData = (oldData, newData, username) => {
  const overrides = [];
  let isNoteShort = false;
  let hasEmptyNote = false;

  for (let i = 0; i < Math.max(oldData.length, newData.length); i++) {
    const oldRow = oldData[i];
    const newRow = newData[i];

    if (JSON.stringify(oldRow) !== JSON.stringify(newRow)) {

      console.log("newRow.override: ", newRow.override);

      if (
        newRow.override !== "" &&
        newRow.override !== "5" &&
        newRow.override !== undefined &&
        newRow.override !== null &&
        newRow.note === ""
      ) {
        hasEmptyNote = true;
        console.log("Empty true");
        return { isNoteShort, hasEmptyNote, changedData: [] };
      }

      console.log("NEW Override: ", newRow.override)

      if (newRow.override !== null && newRow.note.replace(/[^a-zA-Z0-9]/g, '').length < 20 ) {
        isNoteShort = true;
        console.log("Nota < 20 caratteri");
        return { isNoteShort, hasEmptyNote, changedData: [] };
      }

      console.log(newRow);
      const scoreOverrideDTO = ScoreOverrideRequestDTO.create(
        newRow.LE,           // company
        newRow.fiscalYear,   // fiscalYear
        newRow.period,       // period
        newRow.FdC,          // ctrf
        newRow.override,     // overrideScore
        newRow.note          // comment
        // username          // username, se serve aggiungilo
      );

      overrides.push(scoreOverrideDTO);
    }
  }

  return { isNoteShort, hasEmptyNote, overridesDTO: overrides };
};


  const saveChecklistHandler = (overridesDTO) => {
    console.log("Save");
    console.log("initialTableData: ", initialTableData);
    console.log("tableData: ", tableData);

    const batchDTO = BatchScoreOverrideRequestDTO.create(overridesDTO);
    console.log("batchDTO: ", batchDTO)
    setIsLoading(true)

    assessmentServiceApi.saveScoreOverrides(batchDTO, (error, response) => {
      console.log("API Response (POST):", error, response);


      if (!error) {
        console.log("Override salvato con successo!");
        setIsLoading(false)
        //modalDataHandler("", `Override is saved!`, 'notification', () => history.push("/assessment-manager"))
        modalDataHandler("", `Override is saved!`, 'notification', () => history.push("/override-manager"))
      } else {
        setError(() => {
          throw new Error(error);
        });
      }
    });
  };

  //RENDERIZZAZIONE
  return (
    <div className={`d-flex flex-column align-items-center position-relative outerContainer`}>
      <GenericModal
        show={modalShow}
        handleClose={modalCloseHandler}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
      />

      {/* Tabella */}
      {!isLoading && (
        <table {...getTableProps()} className={styles.tableStyle}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    <div className="h-100 position-relative">
                      <div>
                        {column.render("Header")}
                        &nbsp;
                        <div className={column.isSorted ? (column.isSortedDesc ? styles.descOrder : styles.ascOrder) : ''}></div>
                      </div>
                      {column.canFilter ? <div style={{ height: "15px" }}></div> : ""}
                      <div className={`${styles.filter} position-absolute bottom-0`} style={{ left: "10%" }}>
                        {column.canFilter ? column.render('Filter') : null}
                      </div>
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: "center", padding: "1rem" }}>
                  No data available
                </td>
              </tr>
            ) : (
              rows.map((row) => {
                prepareRow(row);
                const isOverall = row.original.FdC.toLowerCase() === "overall";
                return (
                  <tr
                    {...row.getRowProps()}
                    onClick={() => {
                      console.log("show cells: ", row.cells);
                    }}
                    style={{
                      backgroundColor: isOverall ? '#bac7d9' : 'white'
                    }}
                  >
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()} className="text-center" key={cell.column.id}>
                        {["note"].includes(cell.column.id) ? (
                          <input
                            type="text"
                            value={(() => {
                              const shouldReset =
                                row.original.override === "" ||
                                row.original.override === "5" ||
                                row.original.override === undefined ||
                                row.original.override === null;

                              if (shouldReset && cell.value !== "") {
                                const updatedData = [...tableData];
                                updatedData[row.index] = {
                                  ...updatedData[row.index],
                                  [cell.column.id]: ""
                                };
                                setTableData(updatedData);
                                return "";
                              }

                              return cell.value || "";
                            })()}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              const fieldName = cell.column.id;

                              const updatedData = [...tableData];
                              updatedData[row.index] = {
                                ...updatedData[row.index],
                                [fieldName]: newValue
                              };
                              setTableData(updatedData);
                            }}
                            className="form-control"
                            disabled={
                              row.original.override === "" ||
                              row.original.override === "5" ||
                              row.original.override === undefined ||
                              row.original.override === null ||
                              row.original.editable === false
                            }
                          />
                        ) : cell.column.id === "override" ? (
                          <Select
                            data={selectOverride}
                            selectedValue={(() => {
                              const result = getOverrideValueFromScore(selectedOverride[row.index]);
                              return result;
                            })()}
                            isLoading={isLoading}
                            disabled={!row.original.editable}
                            onChange={(event) => {
                              const newValue = event.target.value;
                              console.log("newValue",newValue)
                              const newOverrideValue = getScoreFromOverrideValue(newValue);
                              const updatedData = [...tableData];
                              updatedData[row.index] = {
                                ...updatedData[row.index],
                                override: newOverrideValue
                              };
                              setTableData(updatedData);
                            }}
                          />
                        ) : (
                          cell.render("Cell")
                        )}
                      </td>
                    ))}
                  </tr>
                );
              })
            )}
          </tbody>

        </table>
      )}

      {/* Caricamento */}
      {isLoading && <Loading />}

      {!isLoadingButtons && !isLoading && (
        <div className="d-flex justify-content-center mt-4">
          <SubmitButton
            click={() => {
              const result = getChangedData(initialTableData, tableData);
              console.log("selectedOverrides",selectedOverride)
              console.log(result)
              if (result.hasEmptyNote) {
                modalDataHandler("", "Please insert Note for overrided value", 'error', () => setModalShow(false))
              }
              else if (result.isNoteShort) {
                modalDataHandler("", "Please insert minimum 20 characters for Note to override value", 'error', () => setModalShow(false))
              }
              else {
                modalDataHandler(
                  "Save Override",
                  "Save Override?",
                  "confirmation",
                  () => saveChecklistHandler(result.overridesDTO)
                )
              }

            }
            }
            disabled={disableButtonSave}
          >
            Save

          </SubmitButton>
        </div>
      )}
    </div>

  );

}

export default AssessmentManagerOverride;
//COLONNE
const COLUMNS = [
  {
    Header: "Fiscal Year",
    Footer: "Fiscal Year",
    accessor: "fiscalYear",
    Filter: "",
    disableFilters: true,
    disableSortBy: true,
    canFilter: false
  },
  {
    Header: "Period",
    Footer: "Period",
    accessor: "period",
    id: "period",
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },
  {
    Header: "LE",
    Footer: "LE",
    // accessor: "frozen",
    id: "LE",
    accessor: "LE",
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },

  {
    Header: "FdC",
    Footer: "FdC",
    // accessor: "frozen",
    id: "FdC",
    accessor: row => row.FdC || "",
    Filter: "",
    disableFilters: true,
    disableSortBy: true,
    Cell: ({ value }) => (
      <span style={{ fontWeight: (value).toLowerCase() === "overall" ? "bold" : "normal" }}>
        {value}
      </span>
    )
  },

  {
    Header: "QLT",
    Footer: "qlt",
    // accessor: "action"
    id: "qlt",
    accessor: "qlt",
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },
  {
    Header: "QNT",
    Footer: "qnt",
    // accessor: "action"
    id: "qnt",
    accessor: "qnt",
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },

  {
    Header: "Score",
    Footer: "score",
    // accessor: "action"
    id: "score",
    accessor: "score",
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },

  {
    Header: "Esito",
    Footer: "esito",
    // accessor: "frozen",
    id: "esito",
    accessor: "esito",
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },
  {
    Header: "Override",
    Footer: "override",
    id: "override",
    accessor: "override",
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },

  {
    Header: "Note",
    Footer: "note",
    id: "note",
    accessor: "note",
    Filter: "",
    disableFilters: true,
    disableSortBy: true
  },
];
